import React from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import i18n from 'i18n';
import { WIZARD_STEP } from 'constants/wizardConstants';
import StatusButton from 'components/Common/Buttons/StatusButton';

export const SetupStatus = ({ setStep }) => {
  const jopTitleList = useSelector(state => state.jobTitle.jobTitleListArray);
  const departmentList = useSelector(state => state.department.departmentList);
  const boardList = useSelector(state => state.board.boardList);
  const anniversaryList = useSelector(state => state.anniversary.anniversaryList);
  const menuList = useSelector(state => state.menu.menuList);
  const gnbMenuList = useSelector(state => state.menu.groupMenuList);
  const screen = useSelector(state => state.home.screen);

  return (
    <div>
      <div>
        <h1>{i18n.t('BTY_W_T_CHECK_AGAIN')}</h1>
        <p>{i18n.t('BTY_W_T_MOVE_PAGE')}</p>
        <p>{i18n.t('BTY_W_T_AFTER_PAGE')}</p>
      </div>
      <div className="section">
        <StatusButton
          label={i18n.t('PT_COMMON_POSITION')}
          idx={WIZARD_STEP.SETUP_JOBTITLE}
          setStep={setStep}
          length={jopTitleList.length}
          iconName="position"
        />
        <StatusButton
          label={i18n.t('EM_T_DEPT')}
          idx={WIZARD_STEP.SETUP_DEPARTMENT}
          setStep={setStep}
          length={departmentList.length}
          iconName="department"
        />
        <StatusButton
          label={i18n.t('BTY_W_T_MAIN_PAGE')}
          idx={WIZARD_STEP.SETUP_HOME}
          setStep={setStep}
          length={1}
          screen={screen}
          iconName="home"
        />
        <StatusButton
          label={i18n.t('BTY_W_T_MENU')}
          idx={WIZARD_STEP.SETUP_GNB_MENU}
          setStep={setStep}
          length={menuList.length + gnbMenuList.length}
          iconName="menu"
        />
        <StatusButton
          label={i18n.t('BTY_W_T_BOARD')}
          idx={WIZARD_STEP.SETUP_BOARD}
          setStep={setStep}
          length={boardList.length}
          iconName="post"
        />
        <StatusButton
          label={i18n.t('BTY_W_T_ANNIVERSARY')}
          idx={WIZARD_STEP.SETUP_ANNIVERSARY}
          setStep={setStep}
          length={anniversaryList.length}
          iconName="anniversary"
        />
      </div>
    </div>
  );
};

SetupStatus.propTypes = {
  setStep: PropTypes.func.isRequired,
};
SetupStatus.defaultProps = {};
export default SetupStatus;
